<template>
  <div
    v-for="(method, index) in filteredPaymentMethods"
    :key="index"
    class="gap-4 flex flex-row"
    :class="index < filteredPaymentMethods.length - 1 ? 'pb-3 mb-2' : ''"
  >
    <div class="flex-none h-[27px] min-w-[32px]">
      <img :src="method.fields?.icon?.value?.src" :alt="method.fields.icon?.value.alt" class="mx-auto" />
    </div>
    <div>
      <div class="mb-[3px]">
        <RichText :field="{ value: replaceBookmarks(method.fields?.methodTitle?.value) }" />
      </div>

      <div v-if="showAdditionalContent">
        <div class="mb-3">
          <RichText :field="{ value: replaceBookmarks(method.fields?.methodContent?.value) }" />
        </div>
        <div v-if="showBPAYBillerCode(method.fields?.methodId?.value)" class="my-2">
          <span
            v-if="bpayBillerCode"
            class="inline-flex items-center rounded-lg bg-racq-anti-flash-white py-2 px-4 text-sm text-racq-dark-grey ring-1 ring-inset ring-gray-500/10"
            v-html="bpayBillerCode"
          ></span>
        </div>
        <div v-if="showPaymentReferenceNumber(method.fields?.methodId?.value)" class="my-2">
          <span
            v-if="paymentReferenceNumber"
            class="inline-flex items-center rounded-lg bg-racq-anti-flash-white py-2 px-4 text-sm text-racq-dark-grey ring-1 ring-inset ring-gray-500/10"
            v-html="paymentReferenceNumber"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { replaceBookmark } from '@/utils/bookmark.replace';

const filteredPaymentMethods = ref<any[]>([]);

const props = defineProps<{
  paymentMethods: any[];
  paymentReferenceNumber?: string;
  bpayBillerCode?: string;
  showAdditionalContent: boolean;
  filterPaymentMethods: boolean;
  bindSuccessful: boolean;
}>();

enum paymentMethodIds {
  bpay = 'bpay',
  australiaPost = 'australiaPost',
  phone = 'phone',
  creditCardOrCheque = 'creditCardOrCheque',
  inPerson = 'inPerson',
  payOnline = 'payOnline',
}

const showReferenceNumber = [paymentMethodIds.bpay, paymentMethodIds.payOnline];
const showBillerCode = [paymentMethodIds.bpay];

const paymentReferenceNumberName = 'paymentReferenceNumber';

onMounted(async () => {
  filteredPaymentMethods.value = props.paymentMethods.filter(
    (x) =>
      !props.filterPaymentMethods ||
      x.fields?.methodId?.value !== paymentMethodIds.payOnline ||
      (x.fields?.methodId?.value === paymentMethodIds.payOnline && props.bindSuccessful)
  );
});

const replaceBookmarks = (content: string) => {
  if (props?.paymentReferenceNumber) {
    return replaceBookmark(paymentReferenceNumberName, content, props.paymentReferenceNumber);
  }
  return content;
};

const showPaymentReferenceNumber = (paymentMethodId: string) => {
  return showReferenceNumber.findIndex((x) => x === paymentMethodId) > -1 && props.paymentReferenceNumber;
};

const showBPAYBillerCode = (paymentMethodId: string) => {
  return showBillerCode.findIndex((x) => x === paymentMethodId) > -1;
};
</script>
